module.exports = __webpack_public_path__ + "media/images/course_section_1-2cd6fa95b9c57c1de1c70f3c276610ef.png";